import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useCurrentUser } from "hooks/useCurrentUser";
import useDataFromUserDetails from "hooks/useDataFromUserDetails";

function ChangeProviderGuard({ children, ...rest }) {
  const { userToken } = useCurrentUser();
  const {
    isInactiveDermaProvider,
    isInactivePcProviderLicense,
    isInactiveDermaProviderLicense,
    isInactivePcProvider,
    hasNoDermaProvider,
    hasNoPcProvider,
  } = useDataFromUserDetails();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        userToken &&
        (hasNoDermaProvider ||
          hasNoPcProvider ||
          isInactiveDermaProvider ||
          isInactivePcProviderLicense ||
          isInactiveDermaProviderLicense ||
          isInactivePcProvider) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default ChangeProviderGuard;
